import { defaultRuntimeUser } from '../common/interfaces';
import { useRuntimeConfig } from '.';

export const useRuntimeUser = () => {
  const { user } = useRuntimeConfig();
  return user || defaultRuntimeUser;
};
